import type { ShiftWithSlots } from '../shifts/types'

export const distinctRoles = (shifts: ShiftWithSlots[]): string[] =>
  Array.from(new Set(shifts.map((shift) => shift.roleName)))
